import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-general-errors',
  templateUrl: './general-errors.component.html',
  styleUrls: ['./general-errors.component.scss']
})
export class GeneralErrorsComponent implements OnInit {
  @Input() errors: string[];

  constructor() { }

  ngOnInit(): void {
  }
}
